import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Input,
  InputGroup,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Col,
  FlexboxGrid,
  Container,
  SelectPicker,
  IconButton,
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';


const ViewCollection = () => {


  const [searchKeyword, setSearchKeyword] = useState('');

  const buyer = ['All Collection'].map(
    item => ({ label: item, value: item })
  );

  const [selectedOption, setSelectedOption] = useState('Option 1');

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };












  function handleOpen(arg0: string): void {
    throw new Error('Function not implemented.');
  }

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">View Collection</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/manageCollection">Collection</Breadcrumb.Item>
                <Breadcrumb.Item active>View Collection</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={10} >
              <Stack direction='column' alignItems='flex-start' >
                <label>Collection Name</label>
                <SelectPicker data={buyer} size="xs" appearance="default" placeholder="Collection Name" style={{ width: 200 }} />
              </Stack>

              <Stack direction='column' alignItems='flex-start' >
                <label>Status</label>
                <SelectPicker value={selectedOption}
                  onChange={handleOptionChange}
                  data={[
                    { label: 'All Catalogues (966)', value: 'Option 1' },
                    { label: 'Draft (183)', value: 'Option 2' },
                    { label: 'Active (755)', value: 'Option 3' },
                    { label: 'Inactive (28)', value: 'Option 4' }
                  ]} size="xs" appearance="default" placeholder="Status" style={{ width: 150 }} />
              </Stack>

              <IconButton size="md" icon={<SearchIcon />} style={{ marginTop: '20px' }} active />
            </Stack>
          </Stack>


          <Stack direction='column' alignItems='flex-end' spacing={44}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button>
            </Stack>
            <Stack >
            </Stack>
          </Stack>
        </Stack>

        <Divider className='divide' />


        <Panel>
          <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img1.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 5
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img2.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 7
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img3.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 6
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img4.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 8
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img5.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 2
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img6.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 3
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img7.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 5
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img8.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 4
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img10.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 9
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img11.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 5
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img3.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 7
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img13.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 6
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <div className="col-md-3" onClick={() => handleOpen('md')}>
                <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                  <img src="../src/assets/images/items/img14.jpg" className='imgp' />
                  {/* <div className="overlay">Collection Veiw</div> */}
                  <Panel header="Product Name : T-Shirt">
                    <p>
                      <small>
                        Alias Code : 5
                      </small>
                    </p>
                  </Panel>
                </Panel>
              </div>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Panel>

        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>

      </Container>
    </>
  );
};

export default ViewCollection;